/* NOYA — interacciones (vanilla JS, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll('.ny-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ny-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ny-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Contadores ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = (target % 1 === 0) ? Math.round(val).toLocaleString('es-MX') : val.toFixed(1);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = (target % 1 === 0) ? target.toLocaleString('es-MX') : target.toFixed(1);
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { var t = parseFloat(n.getAttribute('data-count')); n.textContent = t.toLocaleString('es-MX'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Acordeón FAQ ---- */
  function initFaq() {
    var items = document.querySelectorAll('.ny-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.ny-faq__q');
      var a = item.querySelector('.ny-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('ny-open');
        item.classList.toggle('ny-open');
        q.setAttribute('aria-expanded', String(!open));
        a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
      });
    });
  }

  /* ---- Parallax suave del hero ---- */
  function initParallax() {
    if (reduce) return;
    var nodes = document.querySelectorAll('[data-parallax]');
    if (!nodes.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        nodes.forEach(function (n) {
          var speed = parseFloat(n.getAttribute('data-parallax')) || 0.1;
          n.style.transform = 'translate3d(0,' + (y * speed) + 'px,0)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var main = document.getElementById('ny-pdp-main');
    var thumbs = document.querySelectorAll('.ny-pdp__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var wrap = document.querySelector('.ny-pdp__options');
    if (!wrap) return;
    var variants;
    try { variants = JSON.parse(wrap.getAttribute('data-variants')); } catch (e) { return; }
    var form = document.querySelector('.ny-pdp__form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = document.getElementById('ny-pdp-price');
    var addBtn = document.getElementById('ny-pdp-add');
    var selected = {};
    wrap.querySelectorAll('.ny-pdp__chip.is-active').forEach(function (c) { selected[c.getAttribute('data-opt')] = c.getAttribute('data-val'); });

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + ' MXN';
    }
    function update() {
      var match = variants.find(function (v) {
        return (!selected['1'] || v.option1 === selected['1']) &&
               (!selected['2'] || v.option2 === selected['2']) &&
               (!selected['3'] || v.option3 === selected['3']);
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) html += '<del>' + money(match.compare_at_price) + '</del>';
        html += '<span>' + money(match.price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        var span = addBtn.querySelector('span');
        if (span && !match.available) span.textContent = 'Agotado';
      }
    }
    wrap.querySelectorAll('.ny-pdp__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var opt = chip.getAttribute('data-opt');
        wrap.querySelectorAll('.ny-pdp__chip[data-opt="' + opt + '"]').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        selected[opt] = chip.getAttribute('data-val');
        update();
      });
    });
  }

  function init() { initReveals(); initCounters(); initFaq(); initParallax(); initGallery(); initVariants(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
